/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  shouldListVehicles?: boolean;
}

interface ShowFiltersCTAProps {
  scrolled: any;
  ishovered: boolean;
}

export const VehicleResults = styled.section`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: center;
  position: relative;

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const ShowFiltersCTA = styled(animated.button)<{ $ishovered: boolean; $scrolled: boolean }>`
  background: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: none;
  padding: 0;
  width: 56px;
  height: 100px;
  position: ${({ $scrolled }) => ($scrolled ? 'fixed' : 'absolute')};
  background: ${({ $ishovered }) => ($ishovered ? COLORS.grey30 : COLORS.white)};
  left: 0;
  top: ${({ $scrolled }) => ($scrolled ? '40px' : '12px')};
  cursor: pointer;
  transition: background ease-in-out 0.3s;
`;

export const Label = styled(animated.div)`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const ResultsToolbarContainer = styled.section`
  font-family: 'Audi Type', sans-serif;
  font-size: 12px;
  line-height: 26px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${SIZING.unit(1.5)} ${SIZING.unit(3.5)};
  box-shadow: 0 1px 4px #dfdfdf;
  position: relative;
  color: ${COLORS.white};
  background: ${COLORS.black};
  @media ${device.tablet} {
    padding: ${SIZING.unit(1.5)} ${SIZING.unit(5)};
  }
  @media ${device.laptop} {
    padding: ${SIZING.unit(1.5)} ${SIZING.unit(11)};
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  ${({ shouldListVehicles }: StyleProps) =>
    shouldListVehicles &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `};
`;

export const CountNumber = styled.span`
  font-size: 16px;
  font-weight: bold;
  margin-right: ${SIZING.unit(0.5)};
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  height: 30px;
  place-items: center;
  margin-left: ${SIZING.unit(4)};
  @media ${device.tablet} {
    margin-left: ${SIZING.unit(0.4)};
  }
`;
export const ResultCountContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ResultText = styled.p`
  font-family: 'Audi Type';
  color: ${COLORS.black};
  font-size: 16px;
  line-height: 24px;
`;

export const Option = styled.option`
  padding: ${SIZING.unit(1.5)} ${SIZING.unit(2)};
  text-decoration: none;
  color: ${COLORS.grey70};
  background: ${COLORS.wildSand};
  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  border: none;
  cursor: pointer;
  @media ${device.tablet} {
    padding-right: 0px;
    padding-top: 0px;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilterSectionTitle = styled.div`
  font-family: 'Audi Type Extended';
  font-weight: 400;
  margin-bottom: ${SIZING.unit(6)};
  font-size: 28px;
  line-height: 32px;
  width: 100%;
  display: flex;
  flex-direction: flex-start;
  @media ${device.laptopL} {
    font-size: 32px;
    line-height: 48px;
  }
`;

export const Title = styled.div`
  font-family: 'Audi Type';
  font-weight: 700;
  margin-bottom: ${SIZING.unit(1)};
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.grey10};
  @media ${device.laptopL} {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const Subtitle = styled.div`
  font-family: 'Audi Type';
  font-weight: 400;
  margin-bottom: ${SIZING.unit(3)};
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey10};
  @media ${device.laptopL} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const FilterSubtitle = styled.span`
  font-size: 12px;
  color: ${COLORS.grey10};
  margin-right: ${SIZING.unit(0.5)};
  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const Container = styled.div`
  padding-top: ${SIZING.unit(5)};
  background-color: ${COLORS.grey90};
  padding: ${SIZING.unit(2.5)} ${SIZING.unit(2)} 0 ${SIZING.unit(2)};
  @media ${device.laptop} {
    padding: ${SIZING.unit(3.5)} ${SIZING.unit(4)} 0 ${SIZING.unit(4)};
  }
`;

export const CtaContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0px 8px 4px 10px rgba(0, 0, 0, 0.25);
  border: 0.25px solid ${COLORS.grey50};
  background-color: ${COLORS.grey90};
  z-index: 20;
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: 'Audi Type';
  padding: ${SIZING.unit(2)} ${SIZING.unit(4)};
  justify-content: space-between;
  @media ${device.laptopL} {
    flex-direction: row;
  }
`;

export const CtaButton = styled.button<StyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 ${SIZING.unit(1.5)} 0;
  height: 52px;
  width: 100%;
  z-index: 10;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  text-align: center;
  font-size: 12px;
  @media ${device.laptopL} {
    width: 50%;
    margin: 0 ${SIZING.unit(1)};
  }

  ${({ variant }) => {
    if (variant === 'primary')
      return css`
        background: ${({ disabled }: StyleProps) => (disabled ? COLORS.grey30 : COLORS.white)};
        color: ${({ disabled }) => (disabled ? COLORS.grey70 : COLORS.black)};
        border: ${({ disabled }) =>
          disabled ? `1px solid ${COLORS.grey30}` : `1px solid ${COLORS.white}`};
      `;

    if (variant === 'secondary')
      return css`
        background: transparent;
        color: ${COLORS.white};
        border: 1px solid ${COLORS.white};
      `;
    return css`
      border: 1px solid ${COLORS.black};
    `;
  }}
`;

export const FiltersWrapper = styled.div`
  padding: ${SIZING.unit(2.5)} ${SIZING.unit(2)} 0 ${SIZING.unit(2)};
  @media ${device.laptop} {
    padding: ${SIZING.unit(7.5)} ${SIZING.unit(4)} 0 ${SIZING.unit(4)};
  }
`;

export const ClearFiltersWrapper = styled.div`
  background: ${COLORS.grey5};
`;

export const ClearFilters = styled.button`
  font-family: 'Audi Type';
  color: ${COLORS.black};
  max-width: 150px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: underline;
  cursor: pointer;
  background: transparent;
  border: none;
`;
